export const ageTags = (age?: string): string[] => (age ? [age] : []);
